<template>
  <div>
    <!-- Tìm kiếm -->
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row"><i class="fa fa-list"></i>
          <span class="card-label fs-3 ms-1"> Xếp hạng sản phẩm</span>
        </h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Tên:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input placeholder="Nhập tên sản phẩm" v-model="search.name" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Trạng thái:</label>
            <el-row :gutter="10">
              <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                <el-select placeholder="Chọn trạng thái" v-model="search.status">
                  <el-option label="Tất cả" value="5"></el-option>
                  <el-option label="Bình thường" value="1"></el-option>
                  <el-option label="Đã xóa" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage"><i
                    class="fa fa-search"></i></el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <div style="padding: 5px 10px" class="form-row w-100 d-flex flex-row justify-content-between">
          <div class="col-md-6">
            <el-button type="primary" outline native-type="submit" @click="handleDownloadRanking">
              <span class="btn-inner--icon"><i class="fa fa-download"></i></span>
              <span class="btn-inner--text">&nbsp;Xuất bảng xếp hạng</span>
            </el-button>
          </div>
          <div class="col-md-6" style="text-align:right">
            <el-button plain title="Đồng bộ" type="warning" @click="handleSyncData"
              v-loading.fullscreen.lock="isLoading"><i class="el-icon-refresh"></i></el-button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="col-md-12 tbl">
          <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%" fit stripe
            highlight-current-row>
            <el-table-column prop="odoo_name" label="Tên sản phẩm"></el-table-column>
            <el-table-column prop="c_ten_cua_hang" label="Tên cửa hàng"></el-table-column>
            <el-table-column prop="n_tinh_trang" label="Tình trạng" width="120" align="center">
              <template #default="scope">
                <el-tag type="success" v-if="scope.row.n_tinh_trang == 1" :size="size">Hoạt Động</el-tag>
                <el-tag type="danger" v-if="scope.row.n_tinh_trang == 0" :size="size">Đã xóa</el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="f_danh_gia" align="center" label="Đánh giá">
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination @size-change="" @current-change="" :current-page.sync="tableData.pageNum"
          :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { convertToMoney } from "@/utils/stringUtils";
import { saveAs } from 'file-saver'
import { Product } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";

export default {

  data() {
    return {
      store: useStore(),
      size: "",
      tableData: {
        content: [
        ]
      },
      search: {
        name: "",
        status: "5"
      },
      isSearchLoading: false,
      isLoading: false,
      centerDialogVisible: false,
      operation: false,
      validateForm: {

      },
      rules: {

      },
      productList: [],
      fit: "cover",
      pageRequest: {
        columnFilters: {},
        pageSize: 30,
        pageNum: 1
      },
      selected: {},
    };
  },
  methods: {
    convertToMoney(val) {
      return convertToMoney(val) + " đ"
    },
    handleFindPage() {
      this.isSearchLoading = true
      this.pageRequest.columnFilters = {
        name: { value: this.search.name },
        status: { value: this.search.status },
      };

      this.store.dispatch(Product.findPageProductRating, this.pageRequest).then((res) => {
        this.isSearchLoading = false
        if (res.code == 200 && res.data)
          this.tableData = res.data;
        else
          this.tableData = []
      });
    },
    handleSyncData() {
      this.store.dispatch(Product.syncProductRating).then(res => {
        console.log(res)
      })
    },
    handleDownloadRanking() {
      let pageRequest = {
        columnFilters: {
          name: { value: "" },
          status: { value: "5" },
        }
      }
      this.store.dispatch(Product.downloadRankingReport, pageRequest).then((res) => {
        saveAs(new Blob([res]), 'Bảng_xếp_hạng_sản_phẩm.xlsx')
      }).catch(err => {
        console.log("failed")
        console.log(err)
      })
    }
  },
  mounted() {
    this.handleFindPage()

  },
};
</script>
<style lang="scss" scoped>
.tbl {
  height: calc(100vh - 255px);
}

.box-card {
  margin: 10px;
}

.supply-card {
  padding: 5px;
  border: 1px solid #dee2e6;
  background-color: #f8f9fa;
  align-items: center;
  cursor: pointer;
}

.supply-name {
  font-size: 13px;
  font-weight: 500;
  margin-left: 5px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  /* number of lines to show */
  line-clamp: 1;
  -webkit-box-orient: vertical;
}

.supply-text {
  font-size: 13px;
  margin-left: 5px;
}
</style>